/**
 * analytics.js — the one seam every custom-event call site goes through
 * (docs/adr/2026-07-11-analytics-umami-banner-free.md). `window.umami` only exists when
 * `templates/analytics.html` rendered the tracker script, which is gated on
 * `app.analytics.website-id` being set — prod only. Dev, LAN, and every test run leave
 * `window.umami` undefined, so this stays a silent no-op there by construction; no env check
 * needed here. Fire-and-forget: no await, no return value, never read layout.
 *
 * Payload contract (ADR, standing rule): categorical values only — never a player name, account
 * identifier, or free text.
 */
export function track(name, data) {
  window.umami?.track(name, data);
}
